import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Positioning: EFAM .com sells EMS body sculpting equipment. Not rehab,
// not medical. Keep every title and description on that side of the line.
const pages = {
  '/': {
    title: 'EMS Body Sculpting Machines Australia | EFAM Fitness',
    description:
      'Commercial-grade EMS body sculpting machines for homes, studios and salons. 24 models, prices in AUD, Express worldwide delivery in 2-4 weeks, with direct Australian support.',
    indexable: true
  },
  '/full-range': {
    title: 'The Full Range: 24 EMS Body Sculpting Machines | EFAM Fitness',
    description:
      'Compare all 24 EFAM machines, from the compact SoloForge and DualForge units to the QuadForge studio systems, Meridian, Sovereign and the Crown Jewel flagship. AUD pricing, warranty included.',
    indexable: true
  },
  '/safety': {
    title: 'EMS & RF Safety Information | EFAM Fitness',
    description:
      'EFAM safety guidance, contraindications and responsible-use information for EMS and RF body sculpting equipment.',
    indexable: false,
    canonicalPath: '/safety-information'
  },
  '/safety-information': {
    title: 'EMS & RF Safety Information | EFAM Fitness',
    description:
      'EFAM safety guidance, contraindications and responsible-use information for EMS and RF body sculpting equipment. Read before use.',
    indexable: true
  },
  '/terms-of-service': {
    title: 'Terms of Service | EFAM Fitness',
    description: 'Terms applying to EFAM Fitness equipment purchases, warranty and worldwide delivery.',
    indexable: true
  },
  '/privacy-policy': {
    title: 'Privacy Policy | EFAM Fitness',
    description: 'How EFAM Fitness handles personal information and website data.',
    indexable: true
  },
  '/refund-policy': {
    title: 'Refund, Returns & Warranty | EFAM Fitness',
    description:
      'EFAM refund and return information, warranty terms (1 year under $3,000 AUD, 2 years above) and your rights under the Australian Consumer Law.',
    indexable: true
  },
  '/checkout/success': {
    title: 'Order Confirmed | EFAM Fitness',
    description: 'Your EFAM order confirmation.',
    indexable: false
  },
  '/checkout/cancel': {
    title: 'Checkout Cancelled | EFAM Fitness',
    description: 'Your EFAM checkout was cancelled.',
    indexable: false
  }
};

const ensureMeta = (name, attribute = 'name') => {
  let element = document.head.querySelector(`meta[${attribute}="${name}"]`);
  if (!element) {
    element = document.createElement('meta');
    element.setAttribute(attribute, name);
    document.head.appendChild(element);
  }
  return element;
};

const OG_IMAGE =
  'https://customer-assets.emergentagent.com/job_ems-reimagined/artifacts/em6567jv_7579.png';
const OG_IMAGE_ALT = 'EFAM Fitness EMS body sculpting equipment';

const RouteMetadata = () => {
  const location = useLocation();

  useEffect(() => {
    const page = pages[location.pathname] || {
      title: 'Page Not Found | EFAM Fitness',
      description: 'Return to the EFAM Fitness EMS body sculpting equipment store.',
      indexable: false
    };

    document.title = page.title;
    ensureMeta('description').setAttribute('content', page.description);
    ensureMeta('robots').setAttribute(
      'content',
      page.indexable ? 'index,follow,max-image-preview:large' : 'noindex,follow'
    );
    ensureMeta('og:title', 'property').setAttribute('content', page.title);
    ensureMeta('og:description', 'property').setAttribute('content', page.description);
    ensureMeta('twitter:title').setAttribute('content', page.title);
    ensureMeta('twitter:description').setAttribute('content', page.description);
    ensureMeta('twitter:card').setAttribute('content', 'summary_large_image');
    ensureMeta('og:image', 'property').setAttribute('content', OG_IMAGE);
    ensureMeta('og:image:alt', 'property').setAttribute('content', OG_IMAGE_ALT);
    ensureMeta('twitter:image').setAttribute('content', OG_IMAGE);
    ensureMeta('twitter:image:alt').setAttribute('content', OG_IMAGE_ALT);

    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }

    const canonicalPath = page.canonicalPath || (page.indexable ? location.pathname : '/');
    const canonicalUrl = `https://efamfitness.com${canonicalPath === '/' ? '/' : canonicalPath}`;
    canonical.setAttribute('href', canonicalUrl);
    ensureMeta('og:url', 'property').setAttribute('content', canonicalUrl);
  }, [location.pathname]);

  return null;
};

export default RouteMetadata;
